import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Table } from "../../../../../components/ui/Table";
import { FormatInt } from "../../../../../utils/FormatData";
const TableSmryPartners = (props) => {
  const { data } = props;

  const COLUMNS = useMemo(() => {
    if (!data.length) {
      return [];
    }

    return [
      {
        Header: "Fecha de envio",
        accessor: "dt_fecha",
      },
      {
        Header: "Campaña",
        accessor: "vc_campaign",
      },
      {
        Header: "Contactos",
        accessor: "i_contacts",
      },
      {
        Header: "Enviados",
        accessor: "i_sent",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_sent);
          return FormatInt(value);
        },
      },
      {
        Header: "Entregados",
        accessor: "i_deliver",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_deliver);
          return FormatInt(value);
        },
      },
      {
        Header: "SMS",
        accessor: "i_sms",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_sms);
          return FormatInt(value);
        },
      },
      {
        Header: "En Proceso",
        accessor: "i_waiting",

        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_waiting);
          return FormatInt(value);
        },
      },
      {
        Header: "Inválidos",
        accessor: "i_invalid",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_invalid);
          return FormatInt(value);
        },
      },
      {
        Header: "Leídos",
        accessor: "i_readed",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_readed);
          return FormatInt(value);
        },
      },
      {
        Header: "Respuestas",
        accessor: "i_replies",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_replies);
          return FormatInt(value);
        },
      },
      {
        Header: "Acciones",
        accessor: "i_actions",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_actions);
          return FormatInt(value);
        },
      },
    ];
  }, [data]);
  return (
    <div className="bg-white rounded-lg p-3 mt-2">
      <Table
        data={data}
        columns={COLUMNS}
        config={{
          search: true,
          footer: true,
          printfooter: true,
          pageSize: 10,
          perPage: 10,
          export: true,
        }}
      />
    </div>
  );
};

TableSmryPartners.propTypes = {
  data: PropTypes.array,
};

TableSmryPartners.propTypes = {};

export default TableSmryPartners;
